import React, { ReactNode, createContext, useContext, useState } from "react";

type AutoUpdateContextProps = {
  active: boolean;
  setActive: (value: boolean) => void;
};

const AutoUpdateContext = createContext<AutoUpdateContextProps | undefined>(undefined);

export const AutoUpdateProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [active, setActive] = useState<boolean>(true);

  return <AutoUpdateContext.Provider value={{ active, setActive }}>{children}</AutoUpdateContext.Provider>;
};

export const useAutoUpdate = (): AutoUpdateContextProps => {
  const context = useContext(AutoUpdateContext);
  if (!context) throw new Error("useAutoUpdate must be used within an AutoUpdateProvider");
  return context;
};
